export enum launchScreenTypes {
    FETCH_LAUNCH_SCREEN_REQUEST = 'FETCH_LAUNCH_SCREEN_REQUEST',
    EDIT_LAUNCH_SCREEN_REQUEST = 'EDIT_LAUNCH_SCREEN_REQUEST',
    SET_LAUNCH_SCREEN = 'SET_LAUNCH_SCREEN',
}
